"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeARepetition = void 0;
const removeQuestionNode_1 = __importDefault(require("./removeQuestionNode"));
const shiftSubquestionIdsForRepetition_1 = __importDefault(require("./shiftSubquestionIdsForRepetition"));
const visitQuestionNode_1 = __importDefault(require("./visitQuestionNode"));
const removeARepetition = (form, questionNodeId) => {
    const node = form.questions[questionNodeId];
    const parent = node.parentNodeId === 'root' ? form.questionTree : form.questions[node.parentNodeId];
    const repIndex = node.repetitionIndex;
    const count = node.totalRepetitions;
    // Cannot delete last rep
    if (count <= 1)
        return;
    const config = form.rules[form.questions[node.repetitionAncestorId].questionId];
    if (config === null || config === void 0 ? void 0 : config.unLimitedTimes.enabled) {
        config.unLimitedTimes.value -= 1;
    }
    (0, removeQuestionNode_1.default)(parent, node);
    parent.subQuestions
        .filter(ss => ss.questionId === node.questionId)
        .forEach(ss => {
        (0, shiftSubquestionIdsForRepetition_1.default)(ss, node, form, repIndex, count, -1);
        (0, visitQuestionNode_1.default)(ss, n => (0, shiftSubquestionIdsForRepetition_1.default)(n, node, form, repIndex, count, -1));
    });
};
exports.removeARepetition = removeARepetition;
exports.default = exports.removeARepetition;
